module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00566.abf0887e.jpg";